<template>
  <div v-if="dataPermission.includes('SCON_RECEIPT_AGENCY_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Phiếu thu đối tác</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button @click="handleDownloadFile" class="font-medium f12 btn btn-outline-secondary">
          <i class="bx bx-download"></i> Xuất file
        </button>
        <!-- dataPermission.includes('CNPS_DEVICE_ORDER_TRANSFER_CREATE') -->
        <!-- <button
          class="f12 font-medium btn btn-outline-secondary"
          @click="$router.push({ path: '/agent-receipt-add' })"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button> -->
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDatePayment()"
              v-model="datePayment"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian thanh toán
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDateApprove()"
              v-model="dateRangeApprove"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian duyệt
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.textSearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.serial"
              class="form-control f12 hc-37 text-search"
              placeholder="Serial"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.transactionCode"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã giao dịch"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="dataStatus"
              placeholder="Trạng thái"
            ></Select2>
          </div>

          <div class="form-group">
            <Select2
              v-model="search.invoiceStatus"
              :options="dataStatusInvoice"
              placeholder="Trạng thái xuất hoá đơn"
            >
            </Select2>
          </div>

          <div class="form-group">
            <Select2
              v-model="search.saleId"
              :options="dataManager"
              placeholder="Nhân viên"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Vùng"
              v-model="search.regionId"
              :options="dataRegion"
              @change="queryProvince($event)"
            >
            </Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng phiếu thu: {{ pagination.total }}
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="dataLeads"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(email)="data">
                <p>
                  {{ data.item?.createdByEmail }}
                </p>
              </template>
              <template #cell(time)="data">
                <p>
                  <b>Tạo:</b>
                  {{ data.item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p v-if="data.item.timeApprove">
                  <b>Cập nhật:</b>
                  {{ data.item.modifiedDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(agencyName)="data">
                <a
                  :href="`/list-agent-partner-detail/${data.item?.agencyId}`"
                  target="_blank"
                  style="font-weight: 600; font-size: 14px"
                >
                  {{ data.item?.agencyName }}
                </a>
                <p>
                  {{ data.item?.address }}
                </p>
              </template>

              <template #cell(regionName)="data">
                {{ getRegionName(data.item?.regionId) }}
              </template>

              <template #cell(status)="data">
                <span
                  class="badge"
                  :class="`badge-${transformColor(data.item.status, dataStatus)}`"
                >
                  {{ data.item.status | transformData(dataStatus) }}
                </span>
              </template>
              <template #cell(invoiceSate)="data">
                <span
                  class="badge"
                  :class="`badge-${transformColor(data.item.invoiceState, statusInvoice)}`"
                >
                  {{ data.item.invoiceState | transformData(statusInvoice) }}
                </span>
              </template>
              <template #cell(amount)="data">
                {{ data.item?.amount?.toLocaleString('vi-VN') }}
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <a
                    class="dropdown-item"
                    target="_blank"
                    :href="`/agent-receipt-detail/${data.item.id}`"
                  >
                    <i class="bx bx-detail"></i><span>&nbsp;</span>Chi tiết
                  </a>

                  <button
                    v-if="data.item?.status === 'NEW'"
                    class="dropdown-item"
                    @click="
                      data?.item?.source === 'NEXT_AGENT'
                        ? $router.push(`/agent-receipt-oder-form-edit/${data.item.id}`)
                        : $router.push(`/agent-receipt-edit/${data.item.id}`)
                    "
                  >
                    <i class="bx bx-edit"></i><span>&nbsp;</span>Cập nhật
                  </button>

                  <button
                    v-if="data.item?.status === 'NEW'"
                    class="dropdown-item"
                    @click="approvePending(data.item)"
                  >
                    <i class="bx bx-check-circle"></i><span>&nbsp;</span>Chuyển chờ duyệt
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="data.item?.status === 'PENDING_ACCOUNTANT_APPROVAL'"
                    @click="approveItem(data.item)"
                  >
                    <i class="bx bx-check-circle"></i><span>&nbsp;</span>Duyệt
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="
                      data.item?.status === 'PENDING_SA_APPROVAL' &&
                      dataPermission.includes('SCON_RECEIPT_AGENCY_SALE_ADMIN_ACTION')
                    "
                    @click="approveItemSA(data.item)"
                  >
                    <i class="bx bx-check-circle"></i><span>&nbsp;</span>Duyệt
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="
                      data.item?.status === 'PENDING_SA_APPROVAL' &&
                      dataPermission.includes('SCON_RECEIPT_AGENCY_SALE_ADMIN_ACTION')
                    "
                    @click="rejectItemSA(data.item)"
                  >
                    <i class="bx bx-x-circle"></i><span>&nbsp;</span>Từ chối
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="
                      data.item?.status === 'PENDING_ACCOUNTANT_APPROVAL' &&
                      dataPermission.includes('SCON_RECEIPT_AGENCY_ACCOUNTANT_ACTION')
                    "
                    @click="rejectItem(data.item)"
                  >
                    <i class="bx bx-x-circle"></i><span>&nbsp;</span>Từ chối
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="data.item?.status === 'NEW'"
                    @click="approveCencelItem(data.item)"
                  >
                    <i class="bx bx-x-circle"></i><span>&nbsp;</span>Huỷ
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="data.item?.status === 'PENDING_ACCOUNTANT_APPROVAL'"
                    @click="editReceiptCode(data.item)"
                  >
                    <i class="bx bx-edit"></i><span>&nbsp;</span>Sửa mã giao dịch
                  </button>
                  <button class="dropdown-item" @click="handleCreateInvoice(data.item.id)">
                    <i class="bx bx-file"></i><span>&nbsp;</span>Tạo hóa đơn
                  </button>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>

    <b-modal id="modal-noti" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <b-modal id="cancel-moving" centered v-model="cancelMovingCancel">
      <template #modal-header="{ close }">
        <h5>Lý do từ chối</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close(), (reasonReject = '')"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <ValidationObserver>
        <ValidationProvider rules="required|minMaxName_1" vid="reasonReject" name="Lý do từ chối">
          <div slot-scope="{ errors }">
            <div class="text-center m-2">
              <input v-model="reasonReject" />
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </div>
        </ValidationProvider>
      </ValidationObserver>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel(), (reasonReject = '')"> Đóng </b-button>
        <b-button
          variant="primary"
          @click="cancelMoving(itemCancelMoving, reasonReject), (cancelMovingCancel = false)"
          :disabled="reasonReject == ''"
        >
          Đồng ý
        </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { DeviceService } from '@/services/device.service'
  import mxItemAction from './mx-item-action.js'
  import { AgentService } from '@/services/agent.service'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'receiptCode', label: 'Mã phiếu thu' },
    { key: 'time', label: 'Thời gian' },
    { key: 'agencyName', label: 'Đại lý' },
    { key: 'appendixCode', label: 'Mã phu lục' },
    { key: 'email', label: 'Người phụ trách' },
    { key: 'regionName', label: 'Vùng' },
    { key: 'amount', label: 'Số tiền' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'invoiceSate', label: 'Trạng thái xuất hoá đơn' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    mixins: [prepareQueryParamsMixin, mxItemAction],
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        dataLeads: [],
        loading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dataRegion: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dateRangeApprove: {
          startDate: null,
          endDate: null,
        },
        datePayment: {
          startDate: null,
          endDate: null,
        },
        dataManager: [],
        selected: [],
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        warehouseData: [],
        dataStatus: [{ id: '0', text: 'Tất cả' }, ...Config.statusTranferAgent],
        statusInvoice: Config.statusTranferAgentInvoice,
        dataStatusInvoice: [{ id: '0', text: 'Tất cả' }, ...Config.statusTranferAgentInvoice],
        dataReasonTransfer: [{ id: '0', text: 'Tất cả' }, ...Config.reasonTransferWarehouse],
        cancelMovingCancel: false,
        reasonReject: '',
        itemCancelMoving: {},
      }
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
      this.getListStaffBySuperior()
      this.getRegions()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
      selectAll: {
        get: function () {
          return this.dataLeads ? this.selected.length === this.dataLeads.length : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataLeads.forEach(function (item) {
              selected.push(item)
            })
          }
          this.selected = selected
        },
      },
    },
    filters: {
      // lấy ngày, giờ
      formatTime(ms) {
        return (
          new Date(ms).getHours() +
          ':' +
          new Date(ms).getMinutes() +
          ', ' +
          new Date(ms).getDate() +
          '/' +
          (new Date(ms).getMonth() + 1) +
          '/' +
          new Date(ms).getFullYear()
        )
      },
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    methods: {
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataRegion = data.data.map(e => {
            return { id: e.id, text: e.name }
          })
        }
      },
      transformColor(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].color
      },
      showModalCancelMoving(item) {
        this.cancelMovingCancel = true
        this.itemCancelMoving = item
      },

      async fetchWarehouse() {
        const response = await DeviceService.getListSearchWarehouse()
        const data = response.data.map(({ id, name }) => {
          return { id, text: name }
        })
        this.warehouseData = [{ id: '0', text: 'Tất cả' }, ...data]
      },
      transformDate() {
        this.search.startDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.endDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      transformDateApprove() {
        this.search.approveFromDate = moment(this.dateRangeApprove.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.approveToDate = moment(this.dateRangeApprove.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      transformDatePayment() {
        this.search.receiptFromDate = moment(this.datePayment.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.receiptToDate = moment(this.datePayment.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRangeApprove = {
          startDate: null,
          endDate: null,
        }
        this.datePayment = {
          startDate: null,
          endDate: null,
        }
        this.selected = []
        await this.fetchData()
      },

      // Lấy danh sách nhân viên
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            this.dataManager = data.data.map(e => {
              return { id: e.userId, text: e.name }
            })
            this.dataManager.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async fetchData() {
        if (this.search.status === '0') delete this.search.status
        if (this.search.saleId === '0') delete this.search.saleId
        if (this.search.invoiceStatus === '0') delete this.search.invoiceStatus

        try {
          this.tbLoading = true
          const response = await DeviceService.getListTransferAgent(this.search)
          if (response.code === 1000) {
            this.dataLeads = response.data
            this.pagination.total = response?.totalPage?.total || 0
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.error(error)
        } finally {
          this.tbLoading = false
        }
      },

      async handleDownloadFile() {
        try {
          this.loading = true
          const { page, limit, ...params } = this.search
          await AgentService.exportReceiptPartner(params)
        } catch (error) {
          this.showErr(error.response?.data?.message || error.response?.message || error.message)
        } finally {
          this.loading = false
        }
      },
      async handleCreateInvoice(id) {
        try {
          this.loading = true
          const response = await AgentService.createInvoice({ receiptId: id })
          if (response.code === 1000) {
            this.showSuccess(response.message)
            await this.fetchData()
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          this.showErr(error.message)
        } finally {
          this.loading = false
        }
      },
      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },
      showSuccess(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = message
      },
      getRegionName(regionId) {
        if (!regionId || !this.dataRegion || this.dataRegion.length === 0) {
          return ''
        }
        const region = this.dataRegion.find(r => r.id === regionId)
        return region ? region.text : ''
      },
    },
  }
</script>

<style>
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px !important;
  }
</style>
